import '@douyinfe/semi-foundation/lib/es/modal/modal.scss';
import Modal from './Modal';
export default Modal;